import React from "react";
import { Button, Tree, Input, message } from "antd";
import "./permissionSetting.less";
import { axiosPost } from "@/server/index";
import common from "@/public/common";
import { getCookieNew, getSuulierData } from "@/public/utils";
const { TreeNode } = Tree;
const { Search } = Input;
class PermissionSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedKeys: [],
      searchValue: "",
      autoExpandParent: true,
      dataList: [],
      checkedKeys: [],
      gData: [],
      halfCheckedKeys: [],
      setPermissionReqData: {
        roleid: "",
        permissions: [],
        createname: "",
      },
    };
  }

  componentDidMount() {
    this.getPerssionTree();
    console.log(this.props.location.state.fromDashboard);
    this.setState(
      {
        currentRoleData: this.props.location.state.fromDashboard,
      },
      () => {
        this.initsetPermissionReqData();
      },
    );
  }

  // 权限提交数据初始
  initsetPermissionReqData = () => {
    let userInfo = getCookieNew("adminName")
      ? JSON.parse(getCookieNew("adminName"))
      : JSON.parse(localStorage.getItem("otheradminName"));
    let { currentRoleData, setPermissionReqData } = this.state;
    setPermissionReqData.roleid = currentRoleData.roleid;
    setPermissionReqData.createname = userInfo.account;
    this.setState({
      setPermissionReqData,
    });
  };

  // 权限回显初始化
  initRolePermissions = () => {
    let { currentRoleData, gData } = this.state;
    let { permissions } = currentRoleData;
    let copygData = JSON.parse(JSON.stringify(gData));
    let HasChildrenNode = [];
    // 筛出带有children的节点
    let getHasChildrenNode = (copygData) => {
      for (let i = 0; i < copygData.length; i++) {
        for (let key in copygData[i]) {
          if (key === "children" && copygData[i].children.length) {
            HasChildrenNode.push(copygData[i].key);
            getHasChildrenNode(copygData[i]["children"]);
          }
        }
      }
    };
    getHasChildrenNode(copygData);
    // 已经具有的权限（包括带children的权限）
    let arr = [];
    permissions.forEach((item) => {
      arr.push(item.permissionname + "," + item.permissioncode);
    });
    let result = [];
    // 循环 剔除 带children的节点
    for (let i = 0; i < arr.length; i++) {
      if (HasChildrenNode.indexOf(arr[i]) === -1) {
        result.push(arr[i]);
      }
    }
    this.setState({
      checkedKeys: result,
    });
  };

  // 获取权限树
  getPerssionTree = () => {
    axiosPost(common.eurekaUrlDic + "/permission/tree/query", {
      accountId: getCookieNew("accountId"),
      roleType: "system_and_supplier",
      ...getSuulierData(),
    }).then((res) => {
      if (res.status === 200) {
        this.initBoj(res.data.permissions);
        this.setState(
          {
            gData: res.data.permissions,
          },
          () => {
            this.generateList(this.state.gData);
            this.initRolePermissions();
          },
        );
      }
    });
  };

  initBoj = (obj) => {
    for (let i = 0; i < obj.length; i++) {
      for (let k in obj[i]) {
        if (k === "children") {
          this.initBoj(obj[i][k]);
        } else {
          if (k === "id") {
            obj[i].value = obj[i][k];
            delete obj[i][k];
          } else if (k === "permissionname") {
            obj[i].key = obj[i][k] + "," + obj[i].permissioncode;
            obj[i].title = obj[i][k];
            delete obj[i][k];
          }
        }
      }
    }
  };
  generateList = (data) => {
    let { dataList } = this.state;
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      const { key } = node;
      dataList.push({ key, title: key });
      if (node.children) {
        this.generateList(node.children);
      }
    }
    this.setState(
      {
        dataList,
      },
      () => {},
    );
  };

  getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some((item) => item.key === key)) {
          parentKey = node.key;
        } else if (this.getParentKey(key, node.children)) {
          parentKey = this.getParentKey(key, node.children);
        }
      }
    }
    return parentKey;
  };
  onExpand = (expandedKeys) => {
    this.setState({
      expandedKeys,
      autoExpandParent: false,
    });
  };
  onCheck = (checkedKeys, halfCheckedKeys) => {
    this.setState({
      checkedKeys,
      halfCheckedKeys: halfCheckedKeys.halfCheckedKeys,
    });
  };

  onChange = (e) => {
    console.log(e.target);
    let { gData } = this.state;
    const { value } = e.target;
    const expandedKeys = this.state.dataList
      .map((item) => {
        if (item.title.indexOf(value) > -1) {
          return this.getParentKey(item.key, gData);
        }
        return null;
      })
      .filter((item, i, self) => item && self.indexOf(item) === i);
    this.setState({
      expandedKeys,
      searchValue: value,
      autoExpandParent: true,
    });
  };

  // 提交
  submit = () => {
    let { checkedKeys, setPermissionReqData, halfCheckedKeys } = this.state;
    if (!checkedKeys.length) {
      message.warning("请勾选需要设置的权限");
      return;
    }
    let arr = [];
    checkedKeys.forEach((item) => {
      let temp = item.split(",");
      arr.push(temp[1]);
    });
    if (halfCheckedKeys.length) {
      halfCheckedKeys.forEach((item) => {
        let temp = item.split(",");
        arr.push(temp[1]);
      });
    }
    setPermissionReqData.permissions = arr;
    this.setState(
      {
        setPermissionReqData,
      },
      () => {
        let { setPermissionReqData } = this.state;
        axiosPost(common.eurekaUrlDic + "/permission/role/setpermission", {
        ...getSuulierData(),
          ...setPermissionReqData,
        }).then((res) => {
          if (res.status === 200) {
            message.success("设置成功");
          }
        });
      },
    );
  };

  render() {
    const { searchValue, expandedKeys, autoExpandParent } = this.state;
    const loop = (data) =>
      data.map((item) => {
        const index = item.title.indexOf(searchValue);
        const beforeStr = item.title.substr(0, index);
        const afterStr = item.title.substr(index + searchValue.length);
        const title =
          index > -1 ? (
            <span>
              {beforeStr}
              <span style={{ color: "#f50" }}>{searchValue}</span>
              {afterStr}
            </span>
          ) : (
            <span>{item.title}</span>
          );
        if (item.children) {
          return (
            <TreeNode key={item.key} title={title}>
              {loop(item.children)}
            </TreeNode>
          );
        }
        return <TreeNode key={item.key} title={title} />;
      });
    return (
      <div className="PermissionSettings_wrap">
        {this.props.location.state.fromDashboard.rolename ? (
          <div>
            <div className="body">
              <div className="content">
                <div className="header">设置权限</div>
                <div className="title">
                  <p>
                    你正在为角色{" "}
                    <span>
                      {this.props.location.state.fromDashboard.rolename}
                    </span>{" "}
                    设置权限：
                  </p>
                </div>
                <div className="search">
                  <Search
                    style={{ marginBottom: 8, width: 200 }}
                    placeholder="搜索权限"
                    onChange={this.onChange}
                  />
                  <Tree
                    onExpand={this.onExpand}
                    expandedKeys={expandedKeys}
                    autoExpandParent={autoExpandParent}
                    checkable={true}
                    onCheck={this.onCheck}
                    checkedKeys={this.state.checkedKeys}
                  >
                    {loop(this.state.gData)}
                  </Tree>
                </div>
                <div className="submit">
                  <Button
                    type="primary"
                    shape="round"
                    onClick={() => {
                      this.submit();
                    }}
                  >
                    提交
                  </Button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
export default PermissionSettings;



// WEBPACK FOOTER //
// ./src/pages/roleManagement/permissionSettings.js